'use strict';

module.exports = require('./ReactHowler').default;